import { Component, EventEmitter, Input, Output } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-install-tutorial-dialog',
  templateUrl: './install-dialog.component.html',
  standalone: true,
  styleUrls: ['./install-dialog.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(20px)' }))
      ])
    ])
  ],
  imports: [NgIf]
})
export class InstallTutorialDialogComponent {
  @Input() isVisible = false;
  @Output() closed = new EventEmitter<void>();

  close() {
    this.isVisible = false;
    this.closed.emit();
  }
}
